import { ArrayFieldItemTemplateProps } from "@rjsf/utils";
import { Box, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { createContext, useContext } from "react";
import { formatSchemaName } from '@/shared/utils/formatSchemaName';

// Context to track array nesting depth
export const ArrayNestingContext = createContext(0);

export const ArrayFieldItemTemplate = (props: ArrayFieldItemTemplateProps) => {
  const { children, className, index, disabled, readonly, registry } = props;
  const { onRemoveItem, hasRemove } = props.buttonsProps;
  const { RemoveButton } = registry.templates.ButtonTemplates;
  const theme = useTheme();

  // Access itemRefs and sectionTitle from formContext
  const { itemRefs, sectionTitle } = registry.formContext as {
    itemRefs: React.MutableRefObject<HTMLDivElement[]>;
    sectionTitle?: string;
  };

  // Get current nesting depth from context
  const nestingDepth = useContext(ArrayNestingContext);
  const isTopLevel = nestingDepth === 0;

  return (
    <ArrayNestingContext.Provider value={nestingDepth + 1}>
      <Box
        ref={(el: HTMLDivElement | null) => {
          if (isTopLevel && el && itemRefs && itemRefs.current) {
            itemRefs.current[index] = el;
          }
        }}
        className={className}
        sx={{
          mb: 2,
          p: 2,
          border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
          borderRadius: 1,
          backgroundColor: "background.paper",
          boxShadow: isTopLevel ? 0 : 2, // Add shading for top-level items
          scrollMarginTop: "120px",
        }}
      >
        {sectionTitle && isTopLevel && (
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
            {formatSchemaName(sectionTitle)} #{index + 1}
          </Typography>
        )}
        {children}
        {hasRemove && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            <RemoveButton
              disabled={disabled || readonly}
              onClick={onRemoveItem}
              registry={registry}
              uiSchema={props.uiSchema}
            />
          </Box>
        )}
      </Box>
    </ArrayNestingContext.Provider>
  );
};


